const $inject = ["$rootScope", "$http", "moment", "authService"];

const lbaHotelReviewCtrl = function ($rootScope, $http, moment, authService) {
  let vm = this;

  vm.getNumber = getNumber;
  vm.getReviews = getReviews;
  vm.updateReviewPage = updateReviewPage;
  vm.updateReviewSize = updateReviewSize;
  vm.searchText = "";
  vm.reviews = [];
  vm.showModal = false;
  vm.updateStatus = undefined;
  vm.today = moment().format('yyyy-MM-DD');
  vm.username = authService.getUsername();

  vm.reviewSearchSizeOptions = [
    { size: 5 },
    { size: 10 },
    { size: 20 },
    { size: 50 },
    { size: 100 },
  ];

  vm.size = vm.reviewSearchSizeOptions[0];

  vm.resource = {
    header: [],
    rows: null,
    pagination: {
      page: 1,
    },
  };
  vm.filters = "";

  vm.data = {
    HotelId: "",
    ReviewStatus: [],
  };

  var url = `${endPointUrl}/api/v2/hotels/reviews/search`;
  var exportUrl = `${endPointUrl}/api/v2/hotels/reviews/export`;
  var data = vm.data;
  var settings = "";

  vm.searchReviews = function(debtor, startDate, endDate) {
    vm.selectAll = false;
    
    data.ReviewStatus = vm.status.map(status => {
      return status.replace(/\s/g, "");
    });
  
    let debtorIdentifiers =
      debtor != null &&
      debtor.length > 0 &&
      debtor.map(function (d) {
        return d["Name"];
      });

    if (debtor && debtor.length > 0) {
      data.DebtorIdentifiers = debtorIdentifiers;
    } else {
      data.DebtorIdentifiers = null;
    }

    data.Page = 1;
    data.Size = 5;
    vm.size.size = 5;

    if (startDate) {
      data.CreatedUtcFrom = moment(startDate).format('YYYY-MM-DDTHH:mm:ssZ');
    }

    if (endDate) {
      data.CreatedUtcTo = moment(endDate).add(1, 'day').subtract(1, 'millisecond').format('YYYY-MM-DDTHH:mm:ssZ');
    }

    data.Deleted = false;
    getReviews(url, data, settings);
  }

  vm.searching = false;
  function getReviews(url, data, settings) {
    vm.searching = true;

    $http
      .post(url, data, settings)
      .then(function (res) {
        let data = res.data;
        vm.reviews = data.Result.Reviews;

        vm.resource = {
          header:  [
            {name: 'Select', key: 'Identifier'},
            {name: 'Details', key: 'Name'},
            {name: 'Created', key: 'CreatedUtc'},
            {name: 'Debtor', key: 'DebtorIdentifier'},
            {name: 'PNR', key: 'Pnr'},
            {name: 'Score', key: 'OverallRating'},
            {name: 'Status', key: 'ReviewStatusDescription'},
          ],

          rows: vm.reviews,
          pagination: {
            page: 1,
          },
        };

        vm.page = data.Result.Page;
        vm.pages = vm.getNumber(data.Result.NumberPages);
        vm.resultPages = data.Result.NumberPages;
        vm.numberReviews = data.Result.NumberReviews;
        vm.searching = false;
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  vm.status = ["Awaiting Approval"];
  vm.statuses = ["Awaiting Approval", "Declined", "Approved"];
  vm.debtor = null;
  vm.debtors = [];
  vm.endPointUrl = endPointUrl;

  vm.checkAllSelectedReviewsAreAwaiting = function () {
    let allAwaiting = true;
    let atLeastOne = false;
    
    vm.reviews.forEach(review => {
      if (review.selected && allAwaiting) {
        atLeastOne = true;
        allAwaiting = review.ReviewStatusDescription === 'AwaitingApproval';
      }
    })

    return atLeastOne && allAwaiting;
  }

  function updateReviewPage(index) {
    vm.selectAll = false;

    if (index <= 0 || vm.loading) {
      return false;
    }
    vm.page = index;

    data.Page = index;
    vm.getReviews(url, data, settings);
  }

  function updateReviewSize() {
    vm.pageSize = vm.size.size;

    if (vm.pageSize <= 0 || vm.loading) {
      return false;
    }

    vm.page = 1;
    data.Page = 1;

    data.Size = vm.pageSize;
    vm.getReviews(url, data, settings);
  }

  function getDebtors() {
    var debtorODataApiURL = `${vm.endPointUrl}/odata/Debtors?$select=Id,Name,Title`;
    $http
      .get(debtorODataApiURL)
      .then(function (res) {
        let data = res.data;
        vm.loading = false;
        vm.debtors = data.value;
      })
      .catch(function (err) {
        console.log(err);
      });
  }
  getDebtors();

  function getNumber(num) {
    return new Array(num);
  }

  vm.rowClicked = function (e, review) {
    e.preventDefault();
    review.selected = !review.selected;
  };

  vm.openModal = function () {
    vm.updateStatus = undefined;
    vm.showModal = true;
  };

  vm.cancel = function () {
    vm.showModal = false;
  };


  vm.update = function () {
    $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saving' });
    
    let selectedApprovers = [];
    
    vm.reviews.forEach(review => {
      if (review.selected) selectedApprovers.push(review.Identifier);
    })

    $http
      .post(`${endPointUrl}/api/v2/hotels/reviews/approve`, {
        Identifiers: selectedApprovers,
        Status: vm.updateStatus,
        Approver: vm.username,
      })
      .then(function (res) {
        res.data.Result.forEach(item => {
          if (item.Status === 4) {
            let match = vm.reviews.find(review => review.Identifier === item.Identifier);
            match.ReviewStatus = 4;
            match.ReviewStatusDescription = "Approved";
          }
        })
        $rootScope.$broadcast('lbaLoader:loaderState', { state: 'saved' });
        vm.showModal = false;
      })
      .catch(function (err) {
        console.log(err);
        $rootScope.$broadcast('lbaLoader:loaderState', { state: 'error' });
        vm.showModal = false;
      });
  };

  vm.selectAll = false;
  vm.handleSelectAll = function () {
    vm.selectAll = !vm.selectAll;

    vm.reviews.forEach(review => {
      review.selected = vm.selectAll;
    })
  }

  vm.export = function (debtor, startDate, endDate) {
    $rootScope.$broadcast('lbaLoader:loaderState', { state: 'exporting' });
  
    vm.selectAll = false;

    let data = {
      ReturnAnswers: true,
      Deleted: false
    };
    
    data.ReviewStatus = vm.status.map(status => {
      return status.replace(/\s/g, "");
    });
  
    let debtorIdentifiers =
      debtor != null &&
      debtor.length > 0 &&
      debtor.map(function (d) {
        return d["Name"];
      });

    if (debtor && debtor.length > 0) {
      data.DebtorIdentifiers = debtorIdentifiers;
    }

    if (startDate) {
      data.CreatedUtcFrom = moment(startDate).format('YYYY-MM-DDTHH:mm:ssZ');
    }

    if (endDate) {
      data.CreatedUtcTo = moment(endDate).add(1, 'day').subtract(1, 'millisecond').format('YYYY-MM-DDTHH:mm:ssZ');
    }

    $http
      .post(exportUrl, data, settings)
      .then(function (res) {
        
        let tableHeaders = [
          'Debtor', //DebtorIdentifier
          'Hotel ID', //HotelId
          'Provider ID', //ExternalId
          'Provider', //Provider
          'Hotel Name', //Name
          'Hotel City', //City
          'Country', //Country
          'PNR', //Pnr
          'Score', //OverallRating
          'Status', //ReviewStatusDescription
          'Created', //CreatedUtc
        ]

        const rows = [[...tableHeaders]];
        let questions = [];
        let answers = {};
        res.data.Result.forEach((review, i) => {          
          let reviewData = _.pick(review, [
            'DebtorIdentifier',
            'HotelId',
            'ExternalId',
            'Provider',
            'Name',
            'City',
            'Country',
            'Pnr',
            'OverallRating',
            'ReviewStatusDescription']);

          reviewData.CreatedUtc = moment(review.CreatedUtc).format('DD MMMM yyyy');
          
          review.ReviewAnswers.forEach((item) => {
            let reviewObj = {
              reviewIndex: i+1,
                reviewData: item
            };
            if (answers[item.Question.Title]) {
              answers[item.Question.Title].push(reviewObj)
            } else {
              answers[item.Question.Title] = [reviewObj]
            }

            questions.push(item.Question.Title);
          });

          questions = [...new Set(questions)];

          reviewData.OverallRating = Math.round(reviewData.OverallRating);
          rows.push([...Object.values(reviewData)])
        })

        rows[0].push(...questions);

        Object.keys(answers).forEach(answer => {
          let colIndex = rows[0].findIndex(col => col === answer);
          
          answers[answer].forEach(item => {            
            if ([2, 5].includes(item.reviewData.Question.AnswerType)) {
              let AnswerValue = item.reviewData.AnswerValue;
              item.reviewData.AnswerValue = AnswerValue === '0' ? 'No' : 'Yes';
            }
            rows[item.reviewIndex][colIndex] = item.reviewData.AnswerValue.replace(/[\r\n]+/g," ");

          })
        })

        const csvContent = "data:text/csv;charset=utf-8," + "\ufeff" + convertToCSV(rows)
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "hotel-reviews.csv");
        document.body.appendChild(link);
        link.click();
        $rootScope.$broadcast('lbaLoader:loaderState', { state: 'exportSuccess' });
      })

      .catch(function (err) {
        console.log(err);
      });
  }
};

function convertToCSV(arr) {
  return arr.map(it => {
    return Object.values(it).map(val => {
      if (val) {
        return val.toString().replace(/,/g, '-').replace(/\n/g, ' ').replace(/\#/g,'[hash]')}
        else {
          return null
        }
      }).toString();
  }).join('\n')
}

lbaHotelReviewCtrl.$inject = $inject;

export default lbaHotelReviewCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaHotelReview/lbaHotelReviewCtrl.js